export class DownloadAction {

    baseURL: string;

    constructor(baseURL: string) {
        let interimUrl = baseURL.endsWith('/') ? baseURL : baseURL + '/';
        this.baseURL = interimUrl;
    }

    public action = (jobId: string, idToken: string | null): Promise<any> => {
        let downloadUrl = this.baseURL + "downloads/" + jobId;

        return new Promise((resolve, reject) => {
            fetch(downloadUrl, {
                method: 'GET',
                headers: {
                  "Authorization": "Bearer " + idToken,
                  "Accept": "application/json"
                },
              })
                .then(res => res.json())
                .then((data) => {
                  resolve(data);
                })
                .catch((error) => { reject(error) })
        });
    }

}